module.exports = __webpack_public_path__ + "static/assets/5afb11750e9a2b1c269edadc25840b16.svg";